// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9fa1eb4d","642":"c7387f59"}[chunkId] + ".chunk.js";
};